import React from 'react';

interface UserAvatarProps {
  name: string;
  image?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const getInitials = (name: string) => {
  const names = name.trim().split(' ');
  const first = names[0]?.[0] || '';
  const last = names.length > 1 ? names[names.length - 1][0] : '';
  return (first + last).toUpperCase();
};

// Jira-style color palette
const JIRA_COLORS = [
  '#2B6CB0', // dark blue
  '#25855A', // dark green
  '#B7791F', // dark yellow/gold
  '#C53030', // dark red
  '#553C9A', // dark purple
  '#2C7A7B', // dark teal
  '#2A4365', // navy
  '#276749', // forest green
  '#B8860B', // goldenrod
  '#B3541A', // burnt orange
  '#6B46C1', // deep lavender
  '#718096', // gray
];

function stringToJiraColor(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const idx = Math.abs(hash) % JIRA_COLORS.length;
  return JIRA_COLORS[idx];
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  image,
  size = 40,
  className = '',
  style,
}) => {
  const initials = getInitials(name);
  const bgColor = stringToJiraColor(name);
  const avatarStyle: React.CSSProperties = {
    borderRadius: '50%',
    marginRight: '10px',
    height: size,
    width: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: size * 0.4,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    ...style,
  };

  return image ? (
    <img
      src={image}
      alt={name}
      style={{ ...avatarStyle, objectFit: 'cover', background: '#f3f3f3' }}
      className={className}
    />
  ) : (
    <div
      style={{
        ...avatarStyle,
        background: bgColor,
        color: '#fff',
      }}
      className={className}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
